__turbopack_context__.v({
  "cardTiltHost": "style-module-scss-module__Su5d9q__cardTiltHost",
  "container": "style-module-scss-module__Su5d9q__container",
  "grid": "style-module-scss-module__Su5d9q__grid",
  "section": "style-module-scss-module__Su5d9q__section",
  "subtitle": "style-module-scss-module__Su5d9q__subtitle",
  "title": "style-module-scss-module__Su5d9q__title",
});
